<template>
  <v-text-field
      v-model.number="localModel"
      v-bind="localProps"
      :rules="localComputedRules"
      :label="localLabel"
      :type="localType"
      :disabled="disabled || localProps.disabled"
      @input="debounceTriggerExternalValidation"
      :error="!!errorMessage.length"
      :error-messages="errorMessage"
      :persistent-hint="persistenceHintFlag"
      :hint="localHint"
      :suffix="sufix"
      :class="alignAndArrow"
  >
    <template v-slot:append>
      <v-icon
          @click="clickPrependInnerIcon"
      >
        {{ prependInnerIcon }}
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
import {betterParser} from "./shared/parser";
import {CalculationParamIsNotNumber} from "./exceptions/main";
import {isNumber} from "./shared/shared";
import exprEvalParser from "@koumoul/vjsf/lib/utils/expr-eval-parser";
import matchAll from "match-all";
import {mapGetters} from "vuex";

function getObjectValue(obj, path, separator = '.') {
  if (path.startsWith(separator)) {
    // cut off leading separator if exists
    path = path.substring(1)
  }
  if (path.includes(separator)) {
    // if there are more nested elements
    path = path.split(separator)
    const currentPart = path.splice(0, 1)
    path = path.join(separator)
    if (Object.prototype.hasOwnProperty.call(obj, currentPart)) {
      return getObjectValue(obj[currentPart], path)
    } else {
      console.warn('Undefined: ', currentPart)
      return undefined
    }
  } else {
    // final path element
    return obj[path]
  }
}

export default {
  name: "TcnTextField",
  components: {},
  props: {
    value: {default: null},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
  },
  data() {
    return {
      persistenceHintFlag: false,
      calculationResult: null,
      calculationMode: null,
      errorMessage: "",
      parser: betterParser,
      localRules: [],
      hintKeys: null,
      lastAggregateArrSize: null,
      vuexValue: null,
    }
  },
  computed: {
    ...mapGetters(["getByKey", "getRootModel"]),

    localModel: {
      get() {
        return this.value || this.vuexValue
      },
      set(val) {
        this.vuexValue = val
        this.on.input(val)
      },
    },

    // FOR KEEP LIB EXPR PATTERN TO RESOLVE DEPENDENCY VALUES
    expDataFakeWrapper() {
      return this.rootModel !== null ? {parent: {value: this.rootModel}} : null
    },

    sufix() {
      return this.schema['sufix'] || null
    },

    localHint() {
      this.hintKeys = matchAll(this.schema['hint'], /\{(.*?)\}/g).toArray().filter(key => key !== 'q')
      this.fillHintDependencyParams()

      return this.persistenceHintFlag ? this.schema['hint'] : null
    },

    localLabel() {
      return this.schema['label'] || null
    },

    localComputedRules() {
      if (this.required) {
        return [value => !!value || this.$t('required'), ...this.rules, ...this.localRules]
      } else {
        return [...this.rules, ...this.localRules]
      }
    },

    localProps() {
      const global = this.options['fieldProps']
      const textField = this.options['textFieldProps'] !== undefined && this.options['textFieldProps'] !== null ? this.options['textFieldProps'] : {}
      const forThis = this.schema['x-props'] !== undefined && this.schema['x-props'] !== null ? this.schema['x-props'] : {}
      let result = global !== undefined && global !== null ? global : {}
      result = {...result, ...textField}
      result = {...result, ...forThis}

      if (this.schema["readOnly"]) {
        result = {...result, ...{outlined: false, filled: false}}
      }
      return result
    },

    localType() {
      return this.fullSchema.type
    },

    prependInnerIcon() {
      let icon = null;
      switch (this.schema['displayAs']) {
        case "phone": {
          icon = "mdi-phone"
          break;
        }
        case "www": {
          icon = "mdi-web"
          break
        }
        case "email": {
          icon = "mdi-email"
          break
        }
        default: {
          icon = null
        }
      }

      return icon
    },

    alignAndArrow() {
      let align = "c-left "
      switch (this.schema['content-align']) {
        case "right":
          align = "c-right "
          break;
        case "center":
          align = "c-center "
          break;
        default:
          align = "c-left "
      }

      if (this.schema['numberType'] !== 'integer') {
        align += "inputPrice"
      }

      return align
    },
  },
  // watch: {
  //   getRootModel: {
  //     handler() {
  //       console.log("ZMIANA STORA")
  //     },
  //     deep:true
  //   }
  // },
// ilosc (@change)  cena wartosc
// watch: {
//   rootModel: {
//     handler() {
//       console.log("Wykryto zmiane modelu w polu " + this.fullKey + " - " + Date.now())
//       // this.calculateExpr()
//       // this.resolveDependency()
//     },
//     deep: true,
//     immediate: true,
//     // flush: 'post'
//   }
// },
  methods: {
    getValueFromExpr(exp) {
      return exprEvalParser.evaluate(exp, this.expDataFakeWrapper);
    }
    ,

    fillHintDependencyParams() {
      if (this.hintKeys.length > 0) {
        for (const key of this.hintKeys) {
          // remove parent.value.prop.val and check if prop.val exist
          if (this.checkIfDependencyExist(key)) {
            let value = this.getValueFromExpr(key)
            this.schema['hint'] = this.schema['hint'].replace(`{${key}}`, value)
            this.persistenceHintFlag = true
          } else {
            this.persistenceHintFlag = false
          }
        }
      } else {
        this.persistenceHintFlag = true
      }
    }
    ,

    resolveDependency() {
      if (this.schema["x-source"] !== undefined) {
        // remove parent.value.prop.val and check if prop.val exist
        if (this.checkIfDependencyExist(this.schema['x-source'])) {
          let t = this.getValueFromExpr(this.schema["x-source"])
          if (t !== undefined && this.localModel === null && this.rootModel.fullKey !== t) {
            this.$emit('input', {key: this.fullKey, value: t})
          }
        }
      }
      //console.log(`Pole ${this.fullKey} po funkcji resolve dependency ${Date.now()}`)
    }
    ,

    checkIfDependencyExist(expr) {
      let varArray = expr.split(".")
      varArray.shift()
      varArray.shift()
      return this.rootModel[varArray[0]]?.[varArray[1]] !== undefined
    }
    ,

    calculateExprAggregate() {
      console.log("Obliczam agregat")
      let myExpr = this.parser.parse(this.schema['x-calculation'])
      let variables = myExpr.variables({withMembers: true})

      const paramObj = {}
      let mapResults = null // jeżeli aktualna mapa wyników z expr jest większa niż poprzednia to emituj wartość = ograniczenie rerenderów
      variables.forEach(item => {
        if (item.split(".").length > 1) {
          //zagniezdzenie
          let arr = item.split(".")
          if (arr.length === 2) {
            paramObj[arr[0]] = this.rootModel[arr[0]].map(arrObject => arrObject[arr[1]])
          }
          if (arr.length === 3) {
            const t = this.rootModel[arr[0]][arr[1]]
                .map(arrObject => arrObject[arr[2]])
                .filter(item => item !== undefined)
            console.log("Wartosci", t.filter(item => item !== undefined))
            paramObj[arr[0]] = t
            mapResults = t
          }

        } else {
          paramObj[item] = this.rootModel[item]
        }
      })
      myExpr.tokens = myExpr.tokens.filter(item => item.type !== 'IMEMBER')
      const result = myExpr.evaluate(paramObj)
      if (this.calculationResult !== result && !isNaN(result) && this.lastAggregateArrSize !== mapResults) {
        this.lastAggregateArrSize = mapResults
        this.calculationResult = result
        this.$emit('input', {key: this.fullKey, value: parseFloat(result.toFixed(2))})
      } else {
        console.log(`Nie wykryto zmiany po obliczeniach wiec nie emituje wartości z [${this.fullKey}]` + " - " + Date.now())
      }
    }
    ,

    calculateExprWithoutAggregate() {
      let myExpr = this.parser.parse(this.schema['x-calculation'])
      let myIVARTab = myExpr.tokens.filter(item => item.type === 'IVAR').map(item => item.value);

      const paramObj = {}
      myIVARTab.forEach(item => {
        if (isNumber(this.getRootModel[item])) {
          paramObj[item] = this.getRootModel[item]
        } else {
          if (this.getRootModel[item] === null || this.getRootModel[item] === undefined) {
            // console.log(`Parametr ${item} nie jest liczbą = ${this.rootModel[item]}, ustawiam na 0`)
            paramObj[item] = 0
          }
        }
      })

      const result = myExpr.evaluate(paramObj)
      if (this.calculationResult !== result && result !== 0) {
        this.calculationResult = result
       // this.localModel = result
        //this.on.input()
        this.localModel = parseFloat(result.toFixed(2))
        //this.$emit('input', {key: this.fullKey, value: parseFloat(result.toFixed(2))})
      }
    }
    ,

    calculateExpr() {
      this.calculationMode = this.schema['x-options']?.calculation
      if (this.schema['x-calculation'] !== undefined && this.schema['x-calculation'] !== null) {
        try {
          if (this.calculationMode === 'AGGREGATE') {
            this.calculateExprAggregate()
          } else {
            this.calculateExprWithoutAggregate()
          }
        } catch (e) {
          if (e instanceof CalculationParamIsNotNumber) {
            console.error(e.message)
          } else {
            console.error("Źle zdefiniowane wyrażenie dla pola wyliczeniowego:", e.message)
          }
        }
      }
    }
    ,

    debounceTriggerExternalValidation() {
      this.debounceDataLoad()
    }
    ,

    debounceDataLoad: _.debounce(function () {
      if ('x-validation' in this.schema) {
        console.log("TRYB WALIDACJI: " + this.schema['x-validation'].type)
        let httpAction = this.schema['x-validation'].httpAction;
        let url = httpAction.url
        let param = httpAction.paramName
        let responseParam = this.schema['x-validation'].response
        let validResponse = this.schema['x-validation']['valid-response']


        switch (httpAction.operation) {
          case 'POST' : {
            let body = {}
            body[param] = this.value
            this.options.httpLib.post(`${url}`, body)
                .then((response) => {
                  if (response.data?.[responseParam] !== validResponse) {
                    this.errorMessage = response.data[responseParam]
                  } else {
                    this.errorMessage = ""
                  }
                })
                .catch((error) => {
                  console.error(error)
                })
            break;
          }
          case "GET": {
            this.options.httpLib.get(`${url}?${param}=${this.value}`)
                .then((response) => {
                  if (response.data?.[responseParam] !== validResponse) {
                    this.errorMessage = response.data[responseParam]
                  } else {
                    this.errorMessage = ""
                  }
                })
                .catch((error) => {
                  console.error(error)
                })
            break;
          }
          default: {
            console.error("Niepoprawny typ akcji HTTP do walidacji")
          }
        }
      }
    }, 200),

    clickPrependInnerIcon() {
      switch (this.schema['displayAs']) {
        case "phone": {
          window.open(`tel:${this.localModel.replaceAll(" ", "")}`);
          break
        }
        case "email" : {
          window.location = `mailto:${this.localModel}`;
          break
        }
        case "www": {
          let url = "https://" + this.localModel
          window.open(url, '_blank').focus();
          break
        }
      }

    }
  }
  ,
  created() {

  }
  ,
  mounted() {
    console.log("Montuję pole - " + this.fullKey + " - " + Date.now())
    this.calculateExpr()
    if ('x-calculation' in this.schema) {
      this.$watch('getRootModel', (newRootModel) => {
        console.log("CONDITIONAL WATCH DZIALA")
        console.log(newRootModel)
        this.calculateExpr()
      },{deep: true})
    } else {
      console.log("Nie montuje watchera w " + this.fullKey)

    }
  }
  ,
// beforeUpdate() {
//   console.log("Przed updatem - " + this.fullKey + " - " + Date.now())
// },
// updated() {
//   console.log("Po aktualizacji - "  + this.fullKey + " - "  + Date.now())
// }
}
</script>
<i18n lang="i18n">
{
  "en": {
    "required": "This information is required. - local"
  },
  "pl": {
    "required": "Pole jest wymagane. - local"
  }
}
</i18n>
<style lang="css">

.inputPrice input[type='number'] {
  -moz-appearance: textfield;
}

.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.c-left {
  width: 100%;
}

.c-left input {
  text-align: start;
}

.c-right {
  width: 100%;
}

.c-right input {
  text-align: end
}

.c-center {
  width: 100%;
}

.c-center input {
  text-align: center;
}
</style>
